const defaultData = {
  show: false,
  data: null,
};

export const modalDataSelector = (state, modalName) => state.modals[modalName] || defaultData;
